export default "__VITE_ASSET__CkyZehYH__"